import React from 'react';
import { NavigationArrow, Star } from '@phosphor-icons/react';

/**
 * Renders the Directions/Reviews deep-links an enrichment derives from
 * Google's googleMapsLinks at write time (COL-127). exploration_links also
 * carries Google Maps and Website entries, but those are already rendered
 * elsewhere from place_data, so only Directions/Reviews are shown here to
 * avoid duplicating them — and web/Tavily enrichments never populate these
 * two labels (COL-128), so this renders nothing there.
 *
 * Renders nothing when links is missing, empty, or has neither label (older
 * items, non-place enrichments, malformed/partial data, or an unexpectedly
 * long array — only the two known labels are ever read out of it).
 */
export default function ExplorationLinks({ links, compact = false }) {
  const find = (label) =>
    Array.isArray(links)
      ? links.find((link) => link?.label === label && link.url)?.url
      : undefined;

  const directions = find('Directions');
  const reviews = find('Reviews');
  if (!directions && !reviews) return null;

  return (
    <div className={compact ? 'enrichment-card-exploration-links' : 'entity-detail-exploration-links'}>
      {directions && (
        <a href={directions} target="_blank" rel="noopener noreferrer" className="entity-detail-exploration-link">
          <NavigationArrow size={14} />
          Directions
        </a>
      )}
      {reviews && (
        <a href={reviews} target="_blank" rel="noopener noreferrer" className="entity-detail-exploration-link">
          <Star size={14} />
          Reviews
        </a>
      )}
    </div>
  );
}
